// extracted by mini-css-extract-plugin
module.exports = {"divider":"LogoTextBlocks_divider__7mLw_","abrdnWrapper":"LogoTextBlocks_abrdnWrapper__lSlUu"};